// import React, { useEffect, useState, useCallback } from "react";
// import DatePicker from "react-multi-date-picker";
// import useHttp from "../../Hooks/use-http";
// import startPoint from "../../Assets/dropIcon.png";
// import endPoint from "../../Assets/pickIcon.png";
// import styles from "./PastDriverLocation.module.css";

// const PastDriverLocation = ({ emailID }) => {
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [driverPath, setDriverPath] = useState([]);
//   const [details, setDetails] = useState({ appDetails: {}, deviceDetails: {} });
//   const [deviceDataList, setDeviceDataList] = useState([]);
//   const [selectedDeviceIndex, setSelectedDeviceIndex] = useState(0);
//   const { sendRequest, isLoading } = useHttp();

//   const fetchDriverLocation = useCallback(async () => {
//     if (!emailID || !selectedDate) return;

//     try {
//       const formattedDate = selectedDate.toISOString().split("T")[0];
//       const response = await sendRequest({
//         url: "/driverLocation",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: {
//           emailID: localStorage.getItem("user"),
//           data: {
//             emailID,
//             date: formattedDate,
//           },
//         },
//       });

//       setDeviceDataList(Array.isArray(response?.data) ? response.data : []);
//     } catch (error) {
//       console.error("Failed to fetch driver path:", error);
//       setDeviceDataList([]);
//     }
//   }, [emailID, selectedDate, sendRequest]);

//   useEffect(() => {
//     fetchDriverLocation();
//   }, [fetchDriverLocation]);

//   useEffect(() => {
//     if (deviceDataList.length > 0) setSelectedDeviceIndex(0);
//   }, [deviceDataList]);

//   useEffect(() => {
//     if (deviceDataList.length === 0) {
//       setDetails({ appDetails: {}, deviceDetails: {} });
//       setDriverPath([]);
//       return;
//     }

//     const selectedDevice = deviceDataList[selectedDeviceIndex];
//     if (selectedDevice) {
//       const { appDetails, deviceDetails, locationJSON } = selectedDevice;
//       setDetails({
//         appDetails: JSON.parse(appDetails || "{}"),
//         deviceDetails: JSON.parse(deviceDetails || "{}"),
//       });

//       const path = JSON.parse(locationJSON || "[]")
//         .sort((a, b) => Number(a.date) - Number(b.date))
//         .map((entry) => {
//           if (entry.lastLL) {
//             const [lat, lng] = entry.lastLL.split(",").map(Number);
//             return { lat, lng };
//           }
//           return null;
//         })
//         .filter(Boolean);

//       setDriverPath(path);
//       window.initMap && window.initMap(path);
//     }
//   }, [selectedDeviceIndex, deviceDataList]);

//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src =
//       "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs&callback=initMap";
//     script.async = true;
//     document.body.appendChild(script);

//     return () => {
//       document.body.removeChild(script);
//     };
//   }, []);

//   window.initMap = function (pathArray = []) {
//     if (!pathArray.length) return;

//     const map = new window.google.maps.Map(document.getElementById("map"), {
//       zoom: 13,
//       center: pathArray[0] || { lat: 23.0351, lng: 72.4429 },
//     });

//     if (pathArray.length > 1) {
//       new window.google.maps.Polyline({
//         path: pathArray,
//         geodesic: true,
//         strokeColor: "#00b0ff",
//         strokeOpacity: 1.0,
//         strokeWeight: 4,
//       }).setMap(map);

//       new window.google.maps.Marker({
//         position: pathArray[0],
//         map,
//         icon: startPoint,
//         title: "Start Point",
//       });

//       new window.google.maps.Marker({
//         position: pathArray[pathArray.length - 1],
//         map,
//         icon: endPoint,
//         title: "End Point",
//       });
//     }
//   };

//   const noDataAvailable = deviceDataList.length === 0;

//   return (
//     <div className={styles.pastDriver_container}>
//       <div className={styles.pastDriver_sidebar}>
//         <div>
//           <label style={{ fontWeight: "bold", color: "#444" }}>
//             Select Date:
//           </label>{" "}
//           <DatePicker
//             value={selectedDate}
//             maxDate={new Date()}
//             onChange={(dateObj) => {
//               const jsDate =
//                 dateObj instanceof Date ? dateObj : dateObj.toDate();
//               setSelectedDate(jsDate);
//             }}
//             format="YYYY-MM-DD"
//           />
//         </div>

//         <div>
//           <label style={{ fontWeight: "bold", color: "#444" }}>
//             Select Device:
//           </label>
//           <select
//             value={selectedDeviceIndex}
//             onChange={(e) => setSelectedDeviceIndex(Number(e.target.value))}
//             style={{
//               width: "auto",
//               padding: "0.5rem",
//               borderRadius: "6px",
//               border: "1px solid #ccc",
//               marginTop: "0.5rem",
//               marginLeft: "0.2rem",
//             }}
//           >
//             {deviceDataList.map((device, index) => {
//               const parsed = JSON.parse(device.deviceDetails || "{}");
//               return (
//                 <option key={index} value={index}>
//                   {parsed.deviceName || "Device"}
//                 </option>
//               );
//             })}
//           </select>
//         </div>

//         {noDataAvailable && (
//           <div style={{ fontWeight: "bold", color: "#444" }}>
//             📱 No device data available for this date.
//           </div>
//         )}

//         <div
//           style={{
//             backgroundColor: "#fff",
//             padding: "0.6rem",
//             borderRadius: "12px",
//             boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//             borderLeft: "6px solid #00796b",
//             minHeight: "120px",
//           }}
//         >
//           <h3 style={{ color: "#00796b", marginBottom: "0.8rem" }}>
//             📱 Device Info
//           </h3>
//           {!noDataAvailable && details.deviceDetails ? (
//             <ul
//               style={{ listStyle: "none", paddingLeft: 0, lineHeight: "1.4" }}
//             >
//               {Object.entries(details.deviceDetails).map(([key, value]) => (
//                 <li key={key}>
//                   <strong
//                     style={{
//                       textTransform: "capitalize",
//                       color: "#555",
//                       fontSize: "0.9rem",
//                     }}
//                   >
//                     {key}:
//                   </strong>{" "}
//                   <span style={{ color: "#222", fontSize: "0.9rem" }}>
//                     {key.toLowerCase() === "battery" ? `${value}%` : value}
//                   </span>
//                 </li>
//               ))}
//             </ul>
//           ) : (
//             <p style={{ color: "#888" }}>No Data Available</p>
//           )}
//         </div>

//         <div
//           style={{
//             backgroundColor: "#fff",
//             padding: "0.6rem",
//             borderRadius: "12px",
//             boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//             borderLeft: "6px solid #3f51b5",
//             minHeight: "120px",
//           }}
//         >
//           <h3 style={{ color: "#3f51b5", marginBottom: "0.6rem" }}>
//             🧾 App Info
//           </h3>
//           {!noDataAvailable && details.appDetails ? (
//             <ul
//               style={{
//                 listStyle: "none",
//                 paddingLeft: 0,
//                 lineHeight: "1.4",
//                 fontSize: "0.9rem",
//               }}
//             >
//               <li>
//                 <strong style={{ color: "#555" }}>Version Code:</strong>{" "}
//                 <span>{details.appDetails.versionCode}</span>
//               </li>
//               <li>
//                 <strong style={{ color: "#555" }}>Version Name:</strong>{" "}
//                 <span>{details.appDetails.versionName}</span>
//               </li>
//               <li>
//                 <strong style={{ color: "#555" }}>Build Type:</strong>{" "}
//                 <span>{details.appDetails.buildType}</span>
//               </li>
//             </ul>
//           ) : (
//             <p style={{ color: "#888" }}>No Data Available</p>
//           )}
//         </div>
//       </div>

//       <div className={styles.pastDriver_mapWrapper}>
//         {noDataAvailable ? (
//           <div className={styles.pastDriver_noDataBox}>No Data Available</div>
//         ) : (
//           <div
//             id="map"
//             className={styles.pastDriver_map}
//             style={{
//               filter: isLoading ? "blur(2px)" : "none",
//               pointerEvents: isLoading ? "none" : "auto",
//             }}
//           ></div>
//         )}

//         {isLoading && !noDataAvailable && (
//           <div
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: "50%",
//               transform: "translate(-50%, -50%)",
//               backgroundColor: "#fff",
//               padding: "1rem",
//               borderRadius: "8px",
//               boxShadow: "0 0 10px rgba(0,0,0,0.2)",
//             }}
//           >
//             <h3>Loading map...</h3>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PastDriverLocation;

import React, { useEffect, useState, useCallback } from "react";
import DatePicker from "react-multi-date-picker";
import useHttp from "../../Hooks/use-http";
import startPoint from "../../Assets/dropIcon.png";
import endPoint from "../../Assets/pickIcon.png";
import styles from "./PastDriverLocation.module.css";

const PastDriverLocation = ({ emailID }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [driverPath, setDriverPath] = useState([]);
  const [details, setDetails] = useState({ appDetails: {}, deviceDetails: {} });
  const [deviceDataList, setDeviceDataList] = useState([]);
  const [selectedDeviceIndex, setSelectedDeviceIndex] = useState(0);
  const { sendRequest, isLoading } = useHttp();

  const fetchDriverLocation = useCallback(async () => {
    if (!emailID || !selectedDate) return;

    try {
      const formattedDate = selectedDate.toISOString().split("T")[0];
      const response = await sendRequest({
        url: "/driverLocation",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          data: {
            emailID,
            date: formattedDate,
          },
        },
      });

      setDeviceDataList(Array.isArray(response?.data) ? response.data : []);
    } catch (error) {
      console.error("Failed to fetch driver path:", error);
      setDeviceDataList([]);
    }
  }, [emailID, selectedDate, sendRequest]);

  useEffect(() => {
    fetchDriverLocation();
  }, [fetchDriverLocation]);

  useEffect(() => {
    if (deviceDataList.length > 0) setSelectedDeviceIndex(0);
  }, [deviceDataList]);

  useEffect(() => {
    if (deviceDataList.length === 0) {
      setDetails({ appDetails: {}, deviceDetails: {} });
      setDriverPath([]);
      return;
    }

    const selectedDevice = deviceDataList[selectedDeviceIndex];
    if (selectedDevice) {
      const { appDetails, deviceDetails, locationJSON } = selectedDevice;
      setDetails({
        appDetails: JSON.parse(appDetails || "{}"),
        deviceDetails: JSON.parse(deviceDetails || "{}"),
      });

      const path = JSON.parse(locationJSON || "[]")
        .sort((a, b) => Number(a.date) - Number(b.date))
        .map((entry) => {
          if (entry.lastLL) {
            const [lat, lng] = entry.lastLL.split(",").map(Number);
            return { lat, lng };
          }
          return null;
        })
        .filter(Boolean);

      setDriverPath(path);

      if (window.google?.maps) {
        renderMap(path);
      }
    }
  }, [selectedDeviceIndex, deviceDataList]);

  useEffect(() => {
    let scriptLoaded = false;
    let script;

    const loadMapScript = () => {
      if (window.google?.maps) {
        renderMap(driverPath);
        return;
      }

      const existingScript = document.querySelector(
        'script[src*="maps.googleapis.com/maps/api/js"]'
      );

      if (!existingScript) {
        script = document.createElement("script");
        script.src =
          "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs";
        script.async = true;
        script.defer = true;
        script.onload = () => {
          scriptLoaded = true;
          renderMap(driverPath);
        };
        document.body.appendChild(script);
      } else {
        if (window.google?.maps) {
          renderMap(driverPath);
        } else {
          existingScript.onload = () => renderMap(driverPath);
        }
      }
    };

    loadMapScript();

    return () => {
      if (scriptLoaded && script) {
        document.body.removeChild(script);
      }
    };
  }, [driverPath]);

  const renderMap = (pathArray = []) => {
    if (!window.google?.maps || !pathArray.length) return;

    const map = new window.google.maps.Map(document.getElementById("map"), {
      zoom: 13,
      center: pathArray[0] || { lat: 23.0351, lng: 72.4429 },
    });

    if (pathArray.length > 1) {
      new window.google.maps.Polyline({
        path: pathArray,
        geodesic: true,
        strokeColor: "#00b0ff",
        strokeOpacity: 1.0,
        strokeWeight: 4,
      }).setMap(map);

      new window.google.maps.Marker({
        position: pathArray[0],
        map,
        icon: startPoint,
        title: "Start Point",
      });

      new window.google.maps.Marker({
        position: pathArray[pathArray.length - 1],
        map,
        icon: endPoint,
        title: "End Point",
      });
    }
  };

  const noDataAvailable = deviceDataList.length === 0;

  return (
    <div className={styles.pastDriver_container}>
      <div className={styles.pastDriver_sidebar}>
        <div>
          <label style={{ fontWeight: "bold", color: "#444" }}>
            Select Date:
          </label>{" "}
          <DatePicker
            value={selectedDate}
            maxDate={new Date()}
            onChange={(dateObj) => {
              const jsDate =
                dateObj instanceof Date ? dateObj : dateObj.toDate();
              setSelectedDate(jsDate);
            }}
            format="YYYY-MM-DD"
          />
        </div>

        <div>
          <label style={{ fontWeight: "bold", color: "#444" }}>
            Select Device:
          </label>
          <select
            value={selectedDeviceIndex}
            onChange={(e) => setSelectedDeviceIndex(Number(e.target.value))}
            style={{
              width: "auto",
              padding: "0.5rem",
              borderRadius: "6px",
              border: "1px solid #ccc",
              marginTop: "0.5rem",
              marginLeft: "0.2rem",
            }}
          >
            {deviceDataList.map((device, index) => {
              const parsed = JSON.parse(device.deviceDetails || "{}");
              return (
                <option key={index} value={index}>
                  {parsed.deviceName || "Device"}
                </option>
              );
            })}
          </select>
        </div>

        {noDataAvailable && (
          <div style={{ fontWeight: "bold", color: "#444" }}>
            📱 No device data available for this date.
          </div>
        )}

        <div
          style={{
            backgroundColor: "#fff",
            padding: "0.6rem",
            borderRadius: "12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            borderLeft: "6px solid #00796b",
            minHeight: "120px",
          }}
        >
          <h3 style={{ color: "#00796b", marginBottom: "0.8rem" }}>
            📱 Device Info
          </h3>
          {!noDataAvailable && details.deviceDetails ? (
            <ul
              style={{ listStyle: "none", paddingLeft: 0, lineHeight: "1.4" }}
            >
              {Object.entries(details.deviceDetails).map(([key, value]) => (
                <li key={key}>
                  <strong
                    style={{
                      textTransform: "capitalize",
                      color: "#555",
                      fontSize: "0.9rem",
                    }}
                  >
                    {key}:
                  </strong>{" "}
                  <span style={{ color: "#222", fontSize: "0.9rem" }}>
                    {key.toLowerCase() === "battery" ? `${value}%` : value}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p style={{ color: "#888" }}>No Data Available</p>
          )}
        </div>

        <div
          style={{
            backgroundColor: "#fff",
            padding: "0.6rem",
            borderRadius: "12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            borderLeft: "6px solid #3f51b5",
            minHeight: "120px",
          }}
        >
          <h3 style={{ color: "#3f51b5", marginBottom: "0.6rem" }}>
            🧾 App Info
          </h3>
          {!noDataAvailable && details.appDetails ? (
            <ul
              style={{
                listStyle: "none",
                paddingLeft: 0,
                lineHeight: "1.4",
                fontSize: "0.9rem",
              }}
            >
              <li>
                <strong style={{ color: "#555" }}>Version Code:</strong>{" "}
                <span>{details.appDetails.versionCode}</span>
              </li>
              <li>
                <strong style={{ color: "#555" }}>Version Name:</strong>{" "}
                <span>{details.appDetails.versionName}</span>
              </li>
              <li>
                <strong style={{ color: "#555" }}>Build Type:</strong>{" "}
                <span>{details.appDetails.buildType}</span>
              </li>
            </ul>
          ) : (
            <p style={{ color: "#888" }}>No Data Available</p>
          )}
        </div>
      </div>

      <div className={styles.pastDriver_mapWrapper}>
        {noDataAvailable ? (
          <div className={styles.pastDriver_noDataBox}>No Data Available</div>
        ) : (
          <div
            id="map"
            className={styles.pastDriver_map}
            style={{
              filter: isLoading ? "blur(2px)" : "none",
              pointerEvents: isLoading ? "none" : "auto",
            }}
          ></div>
        )}

        {isLoading && !noDataAvailable && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#fff",
              padding: "1rem",
              borderRadius: "8px",
              boxShadow: "0 0 10px rgba(0,0,0,0.2)",
            }}
          >
            <h3>Loading map...</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default PastDriverLocation;
